/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Credits_RemainingInputs */

const en_settings_credits_remaining = /** @type {(inputs: Settings_Credits_RemainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remaining`)
};

const zh_settings_credits_remaining = /** @type {(inputs: Settings_Credits_RemainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`剩余`)
};

/**
* | output |
* | --- |
* | "Remaining" |
*
* @param {Settings_Credits_RemainingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_credits_remaining = /** @type {((inputs?: Settings_Credits_RemainingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Credits_RemainingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_credits_remaining(inputs)
	return zh_settings_credits_remaining(inputs)
});
export { settings_credits_remaining as "settings.credits.remaining" }